// Companies created before reservation emails existed have none (NULL in
// the database); start them with one empty input to fill in.
export const toReservationEmailsFormValues = (
  reservationEmails: string[] | null | undefined,
) =>
  (reservationEmails?.length ? reservationEmails : [undefined]).map(
    (email) => ({ email }),
  );
